// extracted by mini-css-extract-plugin
module.exports = {"section":"D_section__d7XF9"};